import './select.sass';

export default {
	props: {
		options: {
			required: false,
			type: Array,
			default: () => [],
		},
		value: {
			required: false,
		},
		trimCity: {
			required: false,
			type: Boolean,
			default: false
		},
		blank: {
			required: false,
			default: false
		},
		title: {
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			default: false,
			type: Boolean
		},
		reactive: {
			type: Boolean,
			required: false,
			default: false
		},
		isActivity: {
			type: Boolean,
			required: false,
			default: false
		},
		isFlattened: {
			type: Boolean,
			default: false,
		},
		enableEmpty: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			focused: false,
			inputData: '',
			currentElem: {
				value: null,
				id: null,
			}
		};
	},

	template: /*html*/`
		<div class="select" @click="toggleFocus" :class="{ focused: focused && !disabled }">
			<svg
				v-show="!isFlattened"
				class="select__beak"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M19.5 9.99915L12 17.5L4.5 9.99915" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
			</svg>

			<p v-if="currentElem.id" class="select__title" :class="{'select__title--empty':!currentElem.id}">{{ title }}</p>
			<div
				class="select__selected"
				:id="currentElem.id"
				:class="{ disabled: disabled, woTitle: !title, emptyElement: !currentElem.id }"
			>
				<template v-if="trimCity">
					{{ (currentElem.id ? currentElem.value | trimFilter : title) }}
				</template>
				<template v-else>
					{{ (currentElem.id ? currentElem.value : title) }}
				</template>
			</div>
			<transition name="fade">
				<ul class="select__dropdown" v-if="focused && !disabled">
					<li v-for="option in optionsList" :class="{ select__option: true, bold: option.placeholder }" @click="clickHandler($event, option)" :value="option.id" :optionValue="option.value">
						<span v-if="isActivity" class="select__option-cause-text" :class="getCauseClassModificator(option.value)">{{ option.value }}</span>
						<span class="select__option-cause-text" v-else-if="!trimCity">
							{{ option.value }}
						</span>
						<span class="select__option-cause-text" v-else>
							{{ option.value | trimFilter }}
						</span>
					</li>
				</ul>
			</transition>
		</div>
	`,

	filters: {
		trimFilter: function(val) {
			const startIndex = val.indexOf(' ');
			const string = val.substr(startIndex + 1);
			return string;
		}
	},

	computed: {
		optionsList() {
			return this.options.filter(option => option.value !== this.currentElem.value);
		}
	},

	methods: {
		clickHandler(event, option) {
			if (option && option.placeholder) {
				return;
			} else {
				this.chooseOption(event);
			}
		},

		toggleFocus() {
			this.focused = !this.focused;
		},

		chooseOption(element) {
			this.currentElem.id = element.target.getAttribute('value');
			this.currentElem.value = element.target.getAttribute('optionValue').trim();
			this.$emit('change', this.currentElem);
			this.$emit('chooseOption', this.currentElem);
		},

		checkIfTarget(e) {
			if(!e.target.closest('.select')) {
				this.focused = false;
			}
		},
		
		getCauseClassModificator(cause) {
			switch(cause) {
			case 'Списание':
				return 'select__option-cause-text--write-off';
			case 'Приз':
				return 'select__option-cause-text--prize';
			case 'Покупка':
				return 'select__option-cause-text--default';
			case 'Выдан':
				return 'badge badge--issued';
			case 'Отклонен':
				return 'badge badge--rejected';
			case 'Новая':
				return 'badge badge--new';
			}
		}
	},

	watch: {
		options: {
			deep: true,
			handler(options) {
				if(this.reactive && !this.value) {
					this.currentElem = {
						value: options[0].value,
						id: options[0].id
					};
					this.$emit('change', this.currentElem);
				}
			}
		}
	},

	created() {
		if (this.value && this.value.id) {
			this.currentElem = {
				value: this.value.value,
				id: this.value.id
			};
		} else if (!this.enableEmpty && this.options && this.options[0]) {
			this.currentElem = {
				value: this.options[0].value,
				id: this.options[0].id
			};
		}

		this.$emit('change', this.currentElem);
	},

	mounted() {
		document.addEventListener('click', this.checkIfTarget);
	},

	beforeDestroy() {
		document.removeEventListener('click', this.checkIfTarget);
	},
};
